import React from 'react';
import { takeLatest, put, call, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { LOADER_CLOSE, LOADER_OPEN } from '../actions';
import {
  COURSE_GET_COMMENTS,
  COURSE_SET_COMMENT,
  ACTIVITY_SET_LIKEDISLIKE,
  COURSE_NOTIFICATION_SET,
  COURSE_DETAILS_GET,
  QUIZ_SEND_ANSWERS,
  SURVEY_SEND_ANSWERS,
  COMMENT_VISIBILITY_SET,
  SURVEY_QUESTIONS_GET,
  COURSE_RECOMMEND,
  COURSE_LEAVE,
  COURSE_SET_COMMENT_REPLY,
  QUIZ_START_TRACKING,
  EVENT_QUIZ_SEND_ANSWERS,
  EVENT_QUIZ_START,
} from '../actions/coursedetails';
import coursedetails from '../../api/coursedetails';
import { formatPermissions } from '../../../utils/permissions';
import { PERMISSION_SET } from '../actions/permissions';
import { ToastError } from '../../../ui/components/Toast';

function* courseDetailsGet({ id, hideLoader = false }) {
  if (id) {
    try {
      if (!hideLoader) yield put({ type: LOADER_OPEN, fullPage: true });
      const { data: { data: globalData = {} } = {} } = yield call(
        coursedetails.getCourseDetails,
        { id }
      );
      const { data: { data: userData = {} } = {} } = yield call(
        coursedetails.getCourseDetailsUser,
        { id }
      );
      yield put({
        type: COURSE_DETAILS_GET._SUCCESS,
        data: { ...globalData, ...userData },
      });
      const coursePermissions = formatPermissions(userData?.permissions);
      yield put({ type: PERMISSION_SET, data: coursePermissions });
    } catch (err) {
      yield put({ type: COURSE_DETAILS_GET._ERROR });
      // eslint-disable-next-line no-console
      console.log('sagas > coursedetails > courseDetailsGet', err);
    } finally {
      if (!hideLoader) yield put({ type: LOADER_CLOSE });
    }
  }
}

function* courseDetailsGetWatch() {
  yield takeLatest(COURSE_DETAILS_GET._REQUEST, courseDetailsGet);
}

function* courseNotificationSet({ id, action }) {
  if (id) {
    try {
      yield call(coursedetails.courseNotificationSet, { id, action });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('sagas > coursedetails > courseNotificationSet', err);
    }
  }
}

function* courseNotificationSetWatch() {
  yield takeLatest(COURSE_NOTIFICATION_SET._REQUEST, courseNotificationSet);
}

function* activitySetLikeDislike({ id, action_type }) {
  if (id && action_type) {
    try {
      yield call(coursedetails.activitySetLikeDislike, { id, action_type });
      yield put({
        type: ACTIVITY_SET_LIKEDISLIKE._SUCCESS,
        id,
        action_type,
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('sagas > coursedetails > activitySetLikeDislike', err);
    }
  }
}

function* activitySetLikeDislikeWatch() {
  yield takeLatest(ACTIVITY_SET_LIKEDISLIKE._REQUEST, activitySetLikeDislike);
}

function* activitySetComment({ id, body }) {
  try {
    yield put({ type: LOADER_OPEN });
    const {
      data: { result },
    } = yield call(coursedetails.activitySetComment, { id, body });
    if (result) {
      yield put({ type: COURSE_SET_COMMENT._SUCCESS });
      yield put({ type: COURSE_GET_COMMENTS._REQUEST, id });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > coursedetails > activitySetComment', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* activitySetCommentWatch() {
  yield takeLatest(COURSE_SET_COMMENT._REQUEST, activitySetComment);
}

function* activitySetCommentReply({ id, cid, body }) {
  try {
    yield put({ type: LOADER_OPEN });
    const {
      data: { result },
    } = yield call(coursedetails.activitySetCommentReply, { id, cid, body });
    if (result) {
      yield put({ type: COURSE_SET_COMMENT_REPLY._SUCCESS });
      yield put({ type: COURSE_GET_COMMENTS._REQUEST, id });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > coursedetails > activitySetCommentReply', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* activitySetCommentReplyWatch() {
  yield takeLatest(COURSE_SET_COMMENT_REPLY._REQUEST, activitySetCommentReply);
}

function* activityGetCommentList({ id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const {
      data: { data },
    } = yield call(coursedetails.activityGetCommentList, id);
    if (data) {
      yield put({ type: COURSE_GET_COMMENTS._SUCCESS, data });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > coursedetails > activityGetCommentList', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* activityGetCommentListWatch() {
  yield takeLatest(COURSE_GET_COMMENTS._REQUEST, activityGetCommentList);
}

//
function* commentVisibility({ id, published }) {
  try {
    yield put({ type: LOADER_OPEN });
    const {
      data: { data },
    } = yield call(coursedetails.commentVisibility, { id, published });
    if (data) {
      yield put({ type: COMMENT_VISIBILITY_SET._SUCCESS, data });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > coursedetails > commentVisibility', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* commentVisibilityWatch() {
  yield takeLatest(COMMENT_VISIBILITY_SET._REQUEST, commentVisibility);
}

function* quizAnswers({ activity_id, body = {} }) {
  try {
    yield put({ type: LOADER_OPEN, fullPage: true });
    const {
      data: { data },
    } = yield call(coursedetails.quizAnswers, activity_id, body);
    if (data) {
      yield put({ type: QUIZ_SEND_ANSWERS._SUCCESS, data });
      if (data.quiz_passed) {
        const { id } = yield select((state) => state.coursedetails);
        yield put({ type: COURSE_DETAILS_GET._REQUEST, id });
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > coursedetails > quizAnswers', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* quizAnswersWatch() {
  yield takeLatest(QUIZ_SEND_ANSWERS._REQUEST, quizAnswers);
}

function* eventQuizStart({ id }) {
  try {
    yield put({ type: LOADER_OPEN, fullPage: true });
    const {
      data: { data },
    } = yield call(coursedetails.eventQuizStart, id);
    yield put({ type: EVENT_QUIZ_START._SUCCESS, data });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > coursedetails > eventQuizStart', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* eventQuizStartWatch() {
  yield takeLatest(EVENT_QUIZ_START._REQUEST, eventQuizStart);
}

function* eventQuizAnswers({ session_id, body = {} }) {
  try {
    yield put({ type: LOADER_OPEN, fullPage: true });
    const {
      data: { data },
    } = yield call(coursedetails.eventQuizAnswers, session_id, body);
    if (data) {
      yield put({ type: EVENT_QUIZ_SEND_ANSWERS._SUCCESS, data });
      const { id } = yield select((state) => state.coursedetails);
      yield put({ type: COURSE_DETAILS_GET._REQUEST, id });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > coursedetails > eventQuizAnswers', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* eventQuizAnswersWatch() {
  yield takeLatest(EVENT_QUIZ_SEND_ANSWERS._REQUEST, eventQuizAnswers);
}

function* surveyQuestionsGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const {
      data: { data },
    } = yield call(coursedetails.surveyQuestionsGet);
    if (data) {
      yield put({ type: SURVEY_QUESTIONS_GET._SUCCESS, response: data });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > coursedetails > surveyQuestionsGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* surveyQuestionsGetWatch() {
  yield takeLatest(SURVEY_QUESTIONS_GET._REQUEST, surveyQuestionsGet);
}

function* surveyAnswers({ activity_id, body = [], course_id }) {
  try {
    yield put({ type: LOADER_OPEN, fullPage: true });
    const {
      data: { data },
    } = yield call(coursedetails.surveyAnswers, activity_id, body);
    if (data) {
      yield put({
        type: SURVEY_SEND_ANSWERS._SUCCESS,
        response: data,
        body,
        course_id,
      });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > coursedetails > surveyAnswers', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* surveyAnswersWatch() {
  yield takeLatest(SURVEY_SEND_ANSWERS._REQUEST, surveyAnswers);
}

function* courseRecommend({ id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { recommended_info: { recommended } = {} } = yield select(
      (state) => state.coursedetails
    );
    const body = {
      action: !recommended,
    };
    const {
      data: { data },
    } = yield call(coursedetails.courseRecommend, id, body);
    if (data) {
      yield put({ type: COURSE_RECOMMEND._SUCCESS, data });
      yield put({ type: COURSE_DETAILS_GET._REQUEST, id });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > coursedetails > courseRecommend', err);
    toast.error(<ToastError />, {
      toastId: 'courseRecommend',
    });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* courseRecommendWatch() {
  yield takeLatest(COURSE_RECOMMEND._REQUEST, courseRecommend);
}

function* courseLeave({ id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const body = {
      action: true,
    };
    const {
      data: { data },
    } = yield call(coursedetails.courseLeave, id, body);
    if (data) {
      window.location.reload();
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > coursedetails > courseLeave', err);
    toast.error(<ToastError />, {
      toastId: 'courseLeave',
    });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* courseLeaveWatch() {
  yield takeLatest(COURSE_LEAVE._REQUEST, courseLeave);
}

function* quizStartTracking({ id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const body = {
      activity_id: id,
    };
    const {
      data: { data },
    } = yield call(coursedetails.quizStartTracking, body);
    if (data) {
      yield put({ type: QUIZ_START_TRACKING._SUCCESS });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > coursedetails > quizStartTracking', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* quizStartTrackingWatch() {
  yield takeLatest(QUIZ_START_TRACKING._REQUEST, quizStartTracking);
}

export default [
  courseDetailsGetWatch(),
  courseNotificationSetWatch(),
  activitySetCommentWatch(),
  activitySetCommentReplyWatch(),
  commentVisibilityWatch(),
  activitySetLikeDislikeWatch(),
  activityGetCommentListWatch(),
  quizAnswersWatch(),
  eventQuizStartWatch(),
  eventQuizAnswersWatch(),
  surveyQuestionsGetWatch(),
  surveyAnswersWatch(),
  courseRecommendWatch(),
  courseLeaveWatch(),
  quizStartTrackingWatch(),
];
